import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Website} from "./website";
import {filter, first, map, switchMap} from "rxjs/operators";
import * as fromStore from "../../store";
import {Store} from "@ngrx/store";

@Injectable()
export class WebsiteResolver implements Resolve<Website|null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = parseInt(route.params['id'], 10);
      this._store.select(fromStore.getWebsitesLoaded)
        .pipe(
          filter((loaded: boolean): boolean => loaded),
          switchMap(() => this._store.select(fromStore.getWebsitesMap)),
          map((websitesMap: Website[]): Website => websitesMap[websiteId]),
          filter((website: Website): boolean => !!website),
          first()
        )
        .subscribe((website: Website) => {
          this._store.dispatch(new fromStore.UpdateWebsiteSubData(website));

          if (website && (website.isActive || website.cloudflareEnabled)) {
            resolve(website);
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
